angular.module('GatorPad.controllers.Main', [])

.controller('MainController', function ($rootScope, $scope, $location) {
  try {
    if ('localStorage' in window && window['localStorage'] !== null) {
    } else {
      $location.path( "/unsupportedBrowser" );
    }
  } catch (e) {
    console.log("Error: " + e);
  }
});